import { Input, InputGroup } from "rsuite";
import SearchIcon from "@rsuite/icons/Search";

export const SearchInputField = ({
  searchKey,
  setSearchKey,
}: {
  searchKey: string;
  setSearchKey: (value: string) => void;
}) => {
  return (
    <>
      <InputGroup className="listPage-search-button">
        <Input
          placeholder="Search"
          size="md"
          value={searchKey}
          onChange={setSearchKey}
        />
        <InputGroup.Addon>
          <SearchIcon />
        </InputGroup.Addon>
      </InputGroup>
    </>
  );
};
